import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const NotificationsPage = lazy(() => import('./page').then((m) => ({ default: m.NotificationsPage })));

export const notificationRoutes: RouteObject[] = [{ path: 'notifications', element: <NotificationsPage />, handle: { crumb: 'Notifications' } }];
